/** Shared internal / auth theme skin. Blueprint: docs/INTERNAL_INDEX.md */

export const THEME_KEY = 'construx-internal-theme';
export const THEME_DEFAULT = 'blueprint';

export function readTheme() {
  try {
    const v = localStorage.getItem(THEME_KEY);
    if (v === 'light' || v === 'paper' || v === 'blueprint' || v === 'terminal') return v;
  } catch {
    /* ignore */
  }
  return THEME_DEFAULT;
}

export function writeTheme(theme) {
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch {
    /* ignore */
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('construx-internal-theme', { detail: theme }));
  }
}
